export const horseExamResultsText = {
  HORSE_EXAM_RESULT_PASSED: "Passed",
  HORSE_EXAM_RESULT_FAILED: "Failed"
};
